import { Component } from '@angular/core';
import { BaseLogoComponent } from '@shared/ui';

@Component({
    selector: 'mcl-logo',
    imports: [],
    template: `
        <img
            [style.height.px]="70 * scale"
            width="100%"
            src="https://zzzdravje.si/wp-content/uploads/2021/05/zzzlogo.svg"
            alt="MCL Logo"
            class="logo"
            i18n-alt
        />
    `,
})
export class LogoComponent extends BaseLogoComponent {}
